import { MantineThemeOther, ThemeColorsOverride } from '@mantine/core';

/*
  https://maketintsandshades.com/
  Utiliser les 20%, 10% et 0% de shade (vers le noir)
  Ensuite prendre les 10%, 20%, 30%, 40%, 50%, 60%, 70% du tint (vers le blanc)
*/
export const appThemeColors: ThemeColorsOverride = {
  blue: [
    '#a9d0e9',
    '#93c4e4',
    '#7db8de',
    '#68acd9',
    '#52a1d3',
    '#3d95ce',
    '#2789C8', // Couleur voulue pour les boutons (6)
    '#237bb4',
    '#1f6ea0',
    '#1b608c',
  ],
  green: [
    '#d7ecd3',
    '#c9e5c5',
    '#bcdfb6',
    '#aed9a7',
    '#a1d299',
    '#93cc8a',
    '#86c57c',
    '#78bf6d', // Couleur voulue pour les boutons (7)
    '#6cac62',
    '#609957',
  ],
  mintGreen: [
    '#f7fbf2',
    '#eef6e6',
    '#e3f0d0',
    '#d9eadc',
    '#d1f0b9', // Base Color (4)
    '#b7ce9a',
    '#9fb47e',
    '#859b65',
    '#6c824c',
    '#4b5b37',
  ],
  softPink: [
    '#fffcfc',
    '#fbf2f1',
    '#f7d9d8', // Base Color (2)
    '#f0c2c0',
    '#e8a8a6',
    '#de8c8b',
    '#d4706f',
    '#ca5453',
    '#a53d3d',
    '#722e2d',
  ],
};

export const appThemeOther: MantineThemeOther = {
  colors: {
    bgDark: '#173b58',
    bgLight: '#F8F9FA',
    appBlue: '#285174',
    appDarkBlue: '#173b58',
    highLightBlue: '#F1F9FC',
  },
};
